import { BaseApi } from "../../utils/BaseApi";
import { HttpMethodEnum } from "../models/HttpMethodEnum";
import {
  MetaOnboardingConfigResponse,
  MetaOnboardingStatusResponse,
  MetaWhatsappCompleteRequest,
  MetaWhatsappBusinessProfile,
  MetaWhatsappBusinessProfileRequest,
  MetaWhatsappTemplateCreateRequest,
  MetaWhatsappTemplate,
  MetaWhatsappRegisterPhoneRequest,
  MetaWhatsappTestMessageRequest,
} from "../models/Meta/MetaOnboardingModels";

class MetaOnboardingApi extends BaseApi {
  private static instance: MetaOnboardingApi;

  public static get(): MetaOnboardingApi {
    if (!this.instance) {
      this.instance = new MetaOnboardingApi();
    }
    return this.instance;
  }

  public config = BaseApi.createEndpoint<MetaOnboardingConfigResponse, null>(
    HttpMethodEnum.GET,
    "/meta/onboarding/config"
  );

  public status = BaseApi.createEndpoint<MetaOnboardingStatusResponse, null>(
    HttpMethodEnum.GET,
    "/meta/onboarding/status"
  );

  public completeWhatsapp = BaseApi.createEndpoint<
    MetaOnboardingStatusResponse,
    MetaWhatsappCompleteRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/complete");

  public resetWhatsapp = BaseApi.createEndpoint<
    MetaOnboardingStatusResponse,
    null
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/reset");

  public testMessage = BaseApi.createEndpoint<
    { sent: boolean },
    MetaWhatsappTestMessageRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/test-message");

  public validateCloudApi = BaseApi.createEndpoint<
    MetaOnboardingStatusResponse,
    null
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/validate-cloud-api");

  public registerPhone = BaseApi.createEndpoint<
    MetaOnboardingStatusResponse,
    MetaWhatsappRegisterPhoneRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/register-phone");

  public businessProfile = BaseApi.createEndpoint<
    MetaWhatsappBusinessProfile,
    null
  >(HttpMethodEnum.GET, "/meta/onboarding/whatsapp/business-profile");

  public updateBusinessProfile = BaseApi.createEndpoint<
    MetaOnboardingStatusResponse,
    MetaWhatsappBusinessProfileRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/business-profile");

  public greetingTemplate = BaseApi.createEndpoint<
    MetaWhatsappTemplate | null,
    null
  >(HttpMethodEnum.GET, "/meta/onboarding/whatsapp/greeting-template");

  public createGreetingTemplate = BaseApi.createEndpoint<
    MetaWhatsappTemplate,
    null
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/greeting-template");

  public listTemplates = BaseApi.createEndpoint<
    MetaWhatsappTemplate[],
    null
  >(HttpMethodEnum.GET, "/meta/onboarding/whatsapp/templates");

  public createTemplate = BaseApi.createEndpoint<
    MetaWhatsappTemplate,
    MetaWhatsappTemplateCreateRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/templates");

  public sendTemplate = BaseApi.createEndpoint<
    { sent: boolean },
    MetaWhatsappTestMessageRequest
  >(HttpMethodEnum.POST, "/meta/onboarding/whatsapp/templates/send");
}

export const metaOnboardingApi = MetaOnboardingApi.get();
